<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <button class="close close-btn" @click="close()">
              <font-awesome-icon icon="times" />
            </button>
            <div class="row">
              <div class="col-2">
                <div class="access-request-icon">
                  <img :src="getAppIcon(model)">
                </div>
              </div>
              <div class="col-10 access-request-title-content">
                <span><b> Access request: </b> {{model.title}}</span>
              </div>
            </div>
          </div>
          <div class="modal-body" v-if="!isLoading">
            <div class="status-body" v-if="isSuccess">
              <div class="row">
                <div class="col-12">
                  <div class="status-icon success-icon">
                    <font-awesome-icon icon="check"/>
                  </div>
                  <div class="status-content">
                    <b v-html="defaultSuccessMsg"></b>
                  </div>
                </div>
              </div>
            </div>
            <div class="status-body" v-else-if="isFailure">
              <div class="row">
                <div class="col-12">
                  <div class="status-icon failure-icon">
                    <font-awesome-icon icon="times"/>
                  </div>
                  <div class="status-content">
                    <b v-html="defaultErrorMsg"></b>
                  </div>
                </div>
              </div>
            </div>
            <div class="input-body" v-else>
              <div v-if="alert" :class="'alert alert-'+alert.type" role="alert">
                <div class="row">
                  <span class="col-11">{{alert.msg}}</span>
                  <span class="col-1">
                    <button ref="closeBtn" type="button" class="close" data-dismiss="alert" aria-label="Close" @click="alert = null" >
                      <font-awesome-icon icon="times" />
                    </button>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 body-content">
                  <p v-html="defaultText"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group" v-for="field in inputFields" :key="field.name">
                    <input class="mr-1" v-if="field.type == 'checkbox'" type="checkbox" v-model="formData[field.name]" />
                    <label v-html="sanitizer(`${field.display_name}${field.required?'*':''}`) || '&nbsp;'"></label>
                    <!-- input type -->
                    <input v-if="field.type == 'text_input'" type="text" class="form-control" v-model="formData[field.name]" />
                    <textarea v-if="field.type == 'textarea'" type="text" class="form-control" v-model="formData[field.name]"
                    ></textarea>
                    <select v-if="field.type == 'select'" class="form-control" v-model="formData[field.name]">
                      <option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{opt.display}}</option>
                    </select>
                    <small v-if="field.help_text" class="form-text text-muted">{{field.help_text}}</small>
                    <small :ref="'input-'+field.name" class="form-text required-text"></small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <loading-spinner class="p-0" v-else />
          <div class="modal-footer">
            <div class="row">
              <div class="offset-md-4 col-md-4">
                <button class="modal-default-button btn flat-green-btn" @click="submitRequest()" v-if="!isLoading && !isFailure && !isSuccess" >Submit</button>
              </div>
              <div class="col-md-4">
                <button class="modal-default-button btn flat-grey-btn" @click="close()">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import platform from "platform";
import api from "@/api";
import axios from "axios";
import Sanitizer from 'sanitize-html'
import util from "@/util";
import * as CONSTANTS from "../constants.js";
import LoadingSpinner from "./LoadingSpinner";

export default {
  name: "AccessRequestModal",
  props: {
    model: Object,
    linkData: Object,
    categoryId: String
  },
  components: {
    LoadingSpinner
  },
  computed: {
    ...mapGetters(["getUser"])
  },
  data: function() {
    return {
      CONSTANTS,
      defaultText: "",
      defaultSuccessMsg : "Access request submitted successfully.",
      defaultErrorMsg : "An error has occurred. Please try again.",
      inputFields: [],
      formData: {},
      sanitizer : Sanitizer,
      isLoading: false,
      isSuccess: false,
      isFailure: false,
      alert: null,
    };
  },
  mounted() {
    util.postActionClick(this.model, this.getUser.userName, this.$router.currentRoute.path, this.linkData.reference, "open_access_modal")     
    
    this.inputFields = this.linkData.reference.input_fields;
    if (!util.stringIsBlank(this.linkData.reference.intro_msg)) {
      this.defaultText = this.linkData.reference.intro_msg;
    }
    if (!util.stringIsBlank(this.linkData.reference.success_msg)) {
      this.defaultSuccessMsg = this.linkData.reference.success_msg;
    }
    if (!util.stringIsBlank(this.linkData.reference.error_msg)) {
      this.defaultErrorMsg = this.linkData.reference.error_msg;
    }
    if (!this.linkData.reference.input_fields 
        || this.linkData.reference.input_fields.length == 0) {
      this.submitRequest()
    }
  },
  methods: {
    ...mapActions(["addAlert"]),
    close() {
      this.$emit("close");
    },
    async submitRequest() {
      this.isLoading = true;
      if (!this.isValidRequest()) {
        this.isLoading = false;
        return
      }

      let data = {
        requestType: this.linkData.reference.default_request_type,
        accessPackageAssignment: {
          accessPackageId: this.linkData.reference.access_package_id
        }
      };

      for (let v in this.formData) {
        data[v] = this.formData[v];
      }

      let options = {
        headers: {
          Authorization: "Bearer " + this.getUser.azureAccessToken
        }
      };
      try {
        util.postActionClick(this.model, this.getUser.userName, this.$router.currentRoute.path, data, "submit_access_request") 
        let resp = await axios.post(
          CONSTANTS.AZURE_GRAPH_URI + CONSTANTS.AZURE_ACCESS_PACK_REQUEST,
          data,
          options
        );
        console.log("resp", resp);
        util.postActionClick(this.model, this.getUser.userName, this.$router.currentRoute.path, data, "submit_access_request_success")
        this.isSuccess = true
      } catch (err) {
        console.log("Error submitting request", err.response);
        try {
          console.log("ERROR", err.response.data.error.message)
          let msg = ""
          let code = ""
          try {
            let errBody = JSON.parse(err.response.data.error.message)
            msg = errBody[0].Detail;
            code = errBody[0].Code;
          } catch (e) {
            console.log("Unparsable message", err.response.data.error)
            msg = err.response.data.error.message
            code = err.response.data.error.code
          }

          util.postActionClick(this.model, this.getUser.userName, this.$router.currentRoute.path, code+" "+msg, "submit_access_request_failure")
          console.log(msg, code)
          if (code == 'ExistingOpenRequest') {
            this.isFailure = true
            this.defaultErrorMsg = "An existing request is already open for access to this application. " + CONSTANTS.AZURE_ACCESS_PACK_MANAGE_LINK + this.defaultErrorMsg
          } else if (code == 'PolicyRequirementNotMet') {
            this.isFailure = true
            this.defaultErrorMsg ="Requesting access to this application is restricted to users having a specific job profile. " + this.defaultErrorMsg
          } else if (code == 'InvalidRequestExistingGrant') {
            this.isFailure = true
            this.defaultErrorMsg = "Access has already been granted to this application. " + CONSTANTS.AZURE_ACCESS_PACK_ACTIVE_LINK + this.defaultErrorMsg
          } else {
            this.alert = {
              msg: msg,
              type: "danger"
            };
          }
          
        } catch (e) {
          console.log(e)
          this.isFailure = true
        }
      }

      this.isLoading = false;
    },
    isValidRequest() {
      let isValid = true;
      for (let field of this.linkData.reference.input_fields) {
        if (field.required && !this.formData[field.name]) {                
          this.$refs['input-'+field.name][0].textContent = "* This is a required field."          
          isValid = false
        } else {
          this.$refs['input-'+field.name][0].textContent = ""
        }
      }
      return isValid
    },
    getAppIcon(app) {
        if (!app || util.stringIsBlank(app.icon)) {
            return phImage
        } else {
            // if app icon starts with /image/ get it from apps-store
            if (app.icon.startsWith('/image/')) {
                return process.env.VUE_APP_ASSET_BASE_URL + app.id + app.icon
            } else {
                return app.icon
            }
        }
    }
  }
};
</script>

<style scoped>
.required-text{
  width: 100%;
  margin-top: .25rem;
  font-size: 80%;
  color: #dc3545;
}
.form-control {
  border-radius: 0px;
}
.access-request-title-content{
  text-align: left;
  margin: auto;
}
.access-request-icon {
  width: 100%;
  max-width: 50px;
}
.modal-wrapper{
  text-align: center;
  line-height: 18px;
}
.form-group {
  text-align: left;
}
.status-content {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}
.status-icon {
  font-size: 50px;
}
.success-icon {
  color: #7ed321;
}
.failure-icon {
  color: #ed7d31;
}
.status-icon svg {
  margin: auto;
  display: block;
}
.btn {
  height: 43px;
}
.close-btn {
  font-size: 18px;
}
.modal-header {
  display: block;
  padding: 0 0;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.modal-header h4 {
  font-weight: bold;
  font-size: 25px;
  color: #575757;
  margin-top: 20px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 0;
}
.modal-body p {
  margin-bottom: 5px;
}
.body-content {
  margin-bottom: 25px;
}
.modal-footer {
  margin-top: 20px;
  padding: 0;
}
.flat-blue {
  background: #fff;
  color: #666666;
  border: 1px black solid;
  border-radius: 4px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 14px;
}
.flat-blue:focus {
  border: 2px black solid !important;
  border-radius: 4px;
  color: black !important;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  padding-top: 5px !important;
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-footer {
  display: block;
  border-top: none;
}
.modal-default-button {
  float: right;
  padding: 10px 30px;
  width: 100%;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media (max-width: 767px) {
  .modal-default-button {
    margin-bottom: 10px;
  }
}
@media (max-width: 500px) {
  .modal-container {
    width: 100%;
  }
}
</style>
